import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ApolloResponse1aeginapbuksm as ApolloResponse } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { withContext3dkm8s4upl4ld as withContext } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  cancel36mj9lv3a0whl as cancel,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Builder4ra56zvvku0a as Builder } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance29ub64y89bvyi as Companion_getInstance } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ExecutionContext.mjs';
import { plus310ted5e4i90h as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { ProducerScopeb3mmhvfa6ll7 as ProducerScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Produce.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Builder3d75eph7uovs3 as Builder_0 } from './network/http/HttpNetworkTransport.mjs';
import { Builder3moivcm5iuump as Builder_1 } from './network/ws/WebSocketNetworkTransport.mjs';
import { get_defaultDispatcher3rblue9uzsji2 as get_defaultDispatcher } from './internal/dispatchers.js.mjs';
import { ConcurrencyInfo3mmnli95yq2g0 as ConcurrencyInfo } from './ConcurrencyInfo.mjs';
import { NetworkInterceptor22fszyorwx7pt as NetworkInterceptor } from './interceptor/NetworkInterceptor.mjs';
import { ApolloCallpwdxdy18rzuy as ApolloCall } from './ApolloCall.mjs';
import { channelFlow1or0c85tk04v1 as channelFlow } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { Dispatchers_getInstancewbokwrm9sosb as Dispatchers_getInstance } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import {
  flowOn2q2f1gsn1yu9y as flowOn,
  buffer2o7vhreze5nfc as buffer,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Context.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { RetryOnErrorInterceptor28nn2rq891clj as RetryOnErrorInterceptor } from './interceptor/RetryOnErrorInterceptor.mjs';
import { DefaultInterceptorChain10weji0clzo5q as DefaultInterceptorChain } from './interceptor/ApolloInterceptor.mjs';
import { onEach13yrgg7fxnyl6 as onEach } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Transform.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, it, $completion) {
  var tmp = $this.n61_1.e1b(it, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$withContext, $completion) {
  var tmp = $this.o61_1.s61($this.p61_1, $this.q61_1);
  var tmp_0 = ApolloClient$executeAsFlowInternal$slambda$slambda$slambda_0($this.r61_1);
  var tmp_1 = tmp.b1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp_0), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
var ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($this_channelFlow) {
        this.n61_1 = $this_channelFlow;
      }
      t61(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, it), $completion);
      }
      ud(p1, $completion) {
        return this.t61(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda_0($this_channelFlow) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda$slambda$slambda())($this_channelFlow);
  var l = (it, $completion) => i.t61(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $this$channelFlow, $completion) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = $this.u61_1.c61_1.u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    element.x61($this.v61_1);
  }
  try {
    var tmp = withContext($this.u61_1.s60_1.y61_1, ApolloClient$executeAsFlowInternal$slambda$slambda_0($this.u61_1, $this.v61_1, $this.w61_1, $this$channelFlow), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }finally {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = $this.u61_1.c61_1.u1();
    while (_iterator__ex2g4s_0.v1()) {
      var element_0 = _iterator__ex2g4s_0.w1();
      element_0.a62($this.v61_1);
    }
  }
  return Unit_instance;
}
var ApolloClient$executeAsFlowInternal$slambda$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $apolloRequest, $throwing, $this_channelFlow) {
        this.o61_1 = this$0;
        this.p61_1 = $apolloRequest;
        this.q61_1 = $throwing;
        this.r61_1 = $this_channelFlow;
      }
      c1g($this$withContext, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$withContext), $completion);
      }
      ud(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambda$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambda$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda$slambda_0(this$0, $apolloRequest, $throwing, $this_channelFlow) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda$slambda())(this$0, $apolloRequest, $throwing, $this_channelFlow);
  var l = ($this$withContext, $completion) => i.c1g($this$withContext, $completion);
  l.$arity = 1;
  return l;
}
var BuilderClass;
function Builder_2() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.b62_1 = new (Builder())();
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.c62_1 = ArrayList().u2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.d62_1 = ArrayList().u2();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_1.e62_1 = ArrayList().u2();
        var tmp_2 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_2.f62_1 = ArrayList().u2();
        var tmp_3 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_3.g62_1 = ArrayList().u2();
        this.h62_1 = this.g62_1;
        var tmp_4 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_4.i62_1 = ArrayList().u2();
        this.j62_1 = this.i62_1;
        this.k62_1 = Companion_getInstance().p42_1;
        this.l62_1 = null;
        this.m62_1 = null;
        this.n62_1 = null;
        this.o62_1 = null;
        this.p62_1 = null;
        this.q62_1 = null;
        this.r62_1 = null;
        this.s62_1 = null;
        this.t62_1 = null;
        this.u62_1 = null;
        this.v62_1 = null;
        this.w62_1 = null;
        this.x62_1 = null;
        this.y62_1 = null;
        this.z62_1 = null;
        this.a63_1 = null;
        this.b63_1 = null;
        this.c63_1 = null;
        this.d63_1 = null;
        this.e63_1 = null;
        this.f63_1 = null;
        this.g63_1 = null;
        this.h63_1 = null;
        this.i63_1 = true;
      }
      j63() {
        return this.b62_1.n37();
      }
      k63() {
        return plus(plus(plus(this.c62_1, this.d62_1), this.e62_1), this.f62_1);
      }
      c43(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.i63_1 = sendEnhancedClientAwareness;
        return this;
      }
      b43(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.f63_1 = failFastIfOffline;
        return this;
      }
      l63(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.d63_1 = retryOnError;
        return this;
      }
      m63(retryOnErrorInterceptor) {
        // Inline function 'kotlin.apply' call
        this.e63_1 = retryOnErrorInterceptor;
        return this;
      }
      n63(cacheInterceptor) {
        // Inline function 'kotlin.apply' call
        this.g63_1 = cacheInterceptor;
        return this;
      }
      o63(autoPersistedQueryInterceptor) {
        // Inline function 'kotlin.apply' call
        this.h63_1 = autoPersistedQueryInterceptor;
        return this;
      }
      t42(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.l62_1 = httpMethod;
        return this;
      }
      u42(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.m62_1 = httpHeaders;
        return this;
      }
      w42(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.n62_1 = sendApqExtensions;
        return this;
      }
      x42(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.o62_1 = sendDocument;
        return this;
      }
      y42(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.p62_1 = enableAutoPersistedQueries;
        return this;
      }
      z42(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.q62_1 = canBeBatched;
        return this;
      }
      p63(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.u62_1 = serverUrl;
        return this;
      }
      q63(httpServerUrl) {
        // Inline function 'kotlin.apply' call
        this.u62_1 = httpServerUrl;
        return this;
      }
      r63(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.v62_1 = httpEngine;
        return this;
      }
      s63(httpExposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.z62_1 = httpExposeErrorBody;
        return this;
      }
      t63(httpInterceptors) {
        // Inline function 'kotlin.apply' call
        this.g62_1.f5();
        this.g62_1.z2(httpInterceptors);
        return this;
      }
      u63(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.w62_1 = webSocketServerUrl;
        return this;
      }
      v63(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.c63_1 = webSocketServerUrl;
        return this;
      }
      w63(webSocketIdleTimeoutMillis) {
        // Inline function 'kotlin.apply' call
        this.x62_1 = webSocketIdleTimeoutMillis;
        return this;
      }
      x63(wsProtocolFactory) {
        // Inline function 'kotlin.apply' call
        this.y62_1 = wsProtocolFactory;
        return this;
      }
      y63(webSocketEngine) {
        // Inline function 'kotlin.apply' call
        this.a63_1 = webSocketEngine;
        return this;
      }
      z63(webSocketReopenWhen) {
        // Inline function 'kotlin.apply' call
        this.b63_1 = webSocketReopenWhen;
        return this;
      }
      a64(networkTransport) {
        // Inline function 'kotlin.apply' call
        this.r62_1 = networkTransport;
        return this;
      }
      b64(subscriptionNetworkTransport) {
        // Inline function 'kotlin.apply' call
        this.s62_1 = subscriptionNetworkTransport;
        return this;
      }
      c64(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this.b62_1.f5();
        this.b62_1.f46(customScalarAdapters);
        return this;
      }
      d64(listeners) {
        // Inline function 'kotlin.apply' call
        this.i62_1.f5();
        this.i62_1.z2(listeners);
        return this;
      }
      e64(dispatcher) {
        // Inline function 'kotlin.apply' call
        this.t62_1 = dispatcher;
        return this;
      }
      r42(executionContext) {
        // Inline function 'kotlin.apply' call
        this.k62_1 = executionContext;
        return this;
      }
      n37() {
        return new (ApolloClient())(this.i38());
      }
      i38() {
        // Inline function 'kotlin.also' call
        var this_0 = (new (Builder_2())()).c64(this.b62_1.n37());
        this_0.c62_1.z2(this.c62_1);
        this_0.d62_1.z2(this.d62_1);
        this_0.e62_1.z2(this.e62_1);
        this_0.f62_1.z2(this.f62_1);
        return this_0.e64(this.t62_1).r42(this.k62_1).t42(this.l62_1).u42(this.m62_1).q63(this.u62_1).r63(this.v62_1).s63(this.z62_1).t63(this.h62_1).w42(this.n62_1).x42(this.o62_1).y42(this.p62_1).z42(this.q62_1).a64(this.r62_1).b64(this.s62_1).u63(this.w62_1).v63(this.c63_1).y63(this.a63_1).z63(this.b63_1).w63(this.x62_1).x63(this.y62_1).l63(this.d63_1).m63(this.e63_1).n63(this.g63_1).o63(this.h63_1).b43(this.f63_1).d64(this.j62_1).c43(this.i63_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_2);
    BuilderClass = $;
  }
  return BuilderClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.f64_1 = function_0;
      }
      s1d(value, $completion) {
        return this.f64_1(value, $completion);
      }
      n5() {
        return this.f64_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.n5(), other.n5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.n5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var ApolloClient$executeAsFlowInternal$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $apolloRequest, $throwing) {
        this.u61_1 = this$0;
        this.v61_1 = $apolloRequest;
        this.w61_1 = $throwing;
      }
      g64($this$channelFlow, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$channelFlow), $completion);
      }
      ud(p1, $completion) {
        return this.g64((!(p1 == null) ? isInterface(p1, ProducerScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda_0(this$0, $apolloRequest, $throwing) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda())(this$0, $apolloRequest, $throwing);
  var l = ($this$channelFlow, $completion) => i.g64($this$channelFlow, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClient$apolloResponses$slambdaClass;
function ApolloClient$apolloResponses$slambda() {
  if (ApolloClient$apolloResponses$slambdaClass === VOID) {
    class $ {
      t61(response, $completion) {
        if (!(response.n44_1 == null)) {
          throw ensureNotNull(response.n44_1);
        }
        return Unit_instance;
      }
      ud(p1, $completion) {
        return this.t61(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$apolloResponses$slambdaClass = $;
  }
  return ApolloClient$apolloResponses$slambdaClass;
}
function ApolloClient$apolloResponses$slambda_0() {
  var i = new (ApolloClient$apolloResponses$slambda())();
  var l = (response, $completion) => i.t61(response, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClientClass;
function ApolloClient() {
  if (ApolloClientClass === VOID) {
    class $ {
      constructor(builder) {
        this.r60_1 = builder;
        this.v60_1 = this.r60_1.k63();
        this.w60_1 = this.r60_1.j63();
        this.x60_1 = this.r60_1.g63_1;
        this.y60_1 = this.r60_1.h63_1;
        this.z60_1 = this.r60_1.d63_1;
        this.a61_1 = this.r60_1.e63_1;
        this.b61_1 = this.r60_1.f63_1;
        this.c61_1 = this.r60_1.j62_1;
        this.d61_1 = this.r60_1.i63_1;
        this.e61_1 = this.r60_1.k62_1;
        this.f61_1 = this.r60_1.l62_1;
        this.g61_1 = this.r60_1.m62_1;
        this.h61_1 = this.r60_1.n62_1;
        this.i61_1 = this.r60_1.o62_1;
        this.j61_1 = this.r60_1.p62_1;
        this.k61_1 = this.r60_1.q62_1;
        var tmp = this;
        var tmp_0;
        if (!(this.r60_1.r62_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.r60_1.u62_1 == null)) {
            var message = "Apollo: 'httpServerUrl' has no effect if 'networkTransport' is set. Configure httpServerUrl on the networkTransport directly.";
            throw IllegalStateException().o(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!(this.r60_1.v62_1 == null)) {
            var message_0 = "Apollo: 'httpEngine' or 'okHttpClient' has no effect if 'networkTransport' is set. Configure httpEngine on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_0));
          }
          // Inline function 'kotlin.check' call
          if (!this.r60_1.h62_1.s1()) {
            var message_1 = "Apollo: 'addHttpInterceptor' has no effect if 'networkTransport' is set. Configure the interceptors on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_1));
          }
          // Inline function 'kotlin.check' call
          if (!(this.r60_1.z62_1 == null)) {
            var message_2 = "Apollo: 'httpExposeErrorBody' has no effect if 'networkTransport' is set. Configure httpExposeErrorBody on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_2));
          }
          tmp_0 = ensureNotNull(this.r60_1.r62_1);
        } else {
          // Inline function 'kotlin.check' call
          if (!!(this.r60_1.u62_1 == null)) {
            var message_3 = "Apollo: 'serverUrl' is required";
            throw IllegalStateException().o(toString(message_3));
          }
          // Inline function 'kotlin.apply' call
          var this_0 = (new (Builder_0())()).p63(ensureNotNull(this.r60_1.u62_1));
          if (!(this.r60_1.v62_1 == null)) {
            this_0.n64(ensureNotNull(this.r60_1.v62_1));
          }
          if (!(this.r60_1.z62_1 == null)) {
            this_0.o64(ensureNotNull(this.r60_1.z62_1));
          }
          tmp_0 = this_0.p64(this.r60_1.h62_1).n37();
        }
        tmp.t60_1 = tmp_0;
        var tmp_1 = this;
        var tmp_2;
        if (!(this.r60_1.s62_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.r60_1.w62_1 == null)) {
            var message_4 = "Apollo: 'webSocketServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_4));
          }
          // Inline function 'kotlin.check' call
          if (!(this.r60_1.a63_1 == null)) {
            var message_5 = "Apollo: 'webSocketEngine' or 'okHttpClient' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketEngine on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_5));
          }
          // Inline function 'kotlin.check' call
          if (!(this.r60_1.x62_1 == null)) {
            var message_6 = "Apollo: 'webSocketIdleTimeoutMillis' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketIdleTimeoutMillis on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_6));
          }
          // Inline function 'kotlin.check' call
          if (!(this.r60_1.y62_1 == null)) {
            var message_7 = "Apollo: 'wsProtocolFactory' has no effect if 'subscriptionNetworkTransport' is set. Configure wsProtocolFactory on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_7));
          }
          // Inline function 'kotlin.check' call
          if (!(this.r60_1.b63_1 == null)) {
            var message_8 = "Apollo: 'webSocketReopenWhen' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenWhen on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_8));
          }
          // Inline function 'kotlin.check' call
          if (!(this.r60_1.c63_1 == null)) {
            var message_9 = "Apollo: 'webSocketReopenServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_9));
          }
          tmp_2 = ensureNotNull(this.r60_1.s62_1);
        } else {
          var tmp0_elvis_lhs = this.r60_1.w62_1;
          var url = tmp0_elvis_lhs == null ? this.r60_1.u62_1 : tmp0_elvis_lhs;
          var tmp_3;
          if (url == null) {
            tmp_3 = this.t60_1;
          } else {
            // Inline function 'kotlin.apply' call
            var this_1 = (new (Builder_1())()).p63(url);
            if (!(this.r60_1.a63_1 == null)) {
              this_1.w64(ensureNotNull(this.r60_1.a63_1));
            }
            if (!(this.r60_1.x62_1 == null)) {
              this_1.x64(ensureNotNull(this.r60_1.x62_1));
            }
            if (!(this.r60_1.y62_1 == null)) {
              this_1.y64(ensureNotNull(this.r60_1.y62_1));
            }
            if (!(this.r60_1.b63_1 == null)) {
              this_1.z64(this.r60_1.b63_1);
            }
            if (!(this.r60_1.c63_1 == null)) {
              this_1.a65(this.r60_1.c63_1);
            }
            tmp_3 = this_1.n37();
          }
          tmp_2 = tmp_3;
        }
        tmp_1.u60_1 = tmp_2;
        var tmp1_elvis_lhs = this.r60_1.t62_1;
        var dispatcher = tmp1_elvis_lhs == null ? get_defaultDispatcher() : tmp1_elvis_lhs;
        this.s60_1 = new (ConcurrencyInfo())(dispatcher, CoroutineScope_0(dispatcher));
        this.l61_1 = new (NetworkInterceptor())(this.t60_1, this.u60_1);
      }
      b65(query) {
        return ApolloCall().p60(this, query);
      }
      c65(mutation) {
        return ApolloCall().p60(this, mutation);
      }
      q6() {
        cancel(this.s60_1.z61_1);
        this.t60_1.vz();
        this.u60_1.vz();
      }
      m61(apolloRequest, throwing) {
        var flow = channelFlow(ApolloClient$executeAsFlowInternal$slambda_0(this, apolloRequest, throwing));
        return buffer(flowOn(flow, Dispatchers_getInstance().k13_1), 2147483647);
      }
      s61(apolloRequest, throwing) {
        var apolloClient = this;
        // Inline function 'kotlin.apply' call
        var this_0 = apolloRequest.q43();
        this_0.r42(this.s60_1.d44(this.w60_1).d44(apolloClient.e61_1).d44(this_0.e42_1));
        var tmp0_elvis_lhs = this_0.f42_1;
        this_0.t42(tmp0_elvis_lhs == null ? apolloClient.f61_1 : tmp0_elvis_lhs);
        var tmp1_elvis_lhs = this_0.i42_1;
        this_0.w42(tmp1_elvis_lhs == null ? apolloClient.h61_1 : tmp1_elvis_lhs);
        var tmp2_elvis_lhs = this_0.j42_1;
        this_0.x42(tmp2_elvis_lhs == null ? apolloClient.i61_1 : tmp2_elvis_lhs);
        var tmp3_elvis_lhs = this_0.h42_1;
        this_0.y42(tmp3_elvis_lhs == null ? apolloClient.j61_1 : tmp3_elvis_lhs);
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_1 = ArrayList().u2();
        if (!(this_0.l42_1 === true)) {
          // Inline function 'kotlin.collections.orEmpty' call
          var tmp0_elvis_lhs_0 = apolloClient.g61_1;
          var tmp$ret$0 = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
          this_1.z2(tmp$ret$0);
        }
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs_1 = this_0.g42_1;
        var tmp$ret$1 = tmp0_elvis_lhs_1 == null ? emptyList() : tmp0_elvis_lhs_1;
        this_1.z2(tmp$ret$1);
        var headers = this_1.k8();
        this_0.u42(headers);
        var tmp4_elvis_lhs = this_0.k42_1;
        var canBeBatched = tmp4_elvis_lhs == null ? apolloClient.k61_1 : tmp4_elvis_lhs;
        if (!(canBeBatched == null)) {
          this_0.v42('X-APOLLO-CAN-BE-BATCHED', canBeBatched.toString());
        }
        var tmp5_elvis_lhs = this_0.m42_1;
        var tmp;
        if (tmp5_elvis_lhs == null) {
          var tmp6_safe_receiver = apolloClient.z60_1;
          tmp = tmp6_safe_receiver == null ? null : tmp6_safe_receiver(apolloRequest);
        } else {
          tmp = tmp5_elvis_lhs;
        }
        this_0.a43(tmp);
        var tmp7_elvis_lhs = this_0.n42_1;
        this_0.b43(tmp7_elvis_lhs == null ? apolloClient.b61_1 : tmp7_elvis_lhs);
        this_0.c43(apolloClient.d61_1);
        var request = this_0.n37();
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_2 = ArrayList().u2();
        this_2.z2(this.r60_1.c62_1);
        if (!(this.x60_1 == null)) {
          this_2.n2(this.x60_1);
        }
        this_2.z2(this.r60_1.d62_1);
        if (!(this.y60_1 == null)) {
          this_2.n2(this.y60_1);
        }
        this_2.z2(this.r60_1.e62_1);
        var tmp0_elvis_lhs_2 = this.a61_1;
        this_2.n2(tmp0_elvis_lhs_2 == null ? RetryOnErrorInterceptor() : tmp0_elvis_lhs_2);
        this_2.z2(this.r60_1.f62_1);
        this_2.n2(this.l61_1);
        var allInterceptors = this_2.k8();
        // Inline function 'kotlin.let' call
        var it = (new (DefaultInterceptorChain())(allInterceptors, 0)).f65(request);
        var tmp_0;
        if (throwing) {
          tmp_0 = onEach(it, ApolloClient$apolloResponses$slambda_0());
        } else {
          tmp_0 = it;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'ApolloClient');
    ApolloClientClass = $;
  }
  return ApolloClientClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Builder_2 as Builder3lcn00uc5gcy3,
};
//endregion

//# sourceMappingURL=ApolloClient.mjs.map
